module.exports = __webpack_public_path__ + "img/logo-stella.44a3446e.png";